<template>
  <RfRetentionInterstitialMobileDevice
    v-if="
      isMobile &&
      ['android_os', 'ios'].includes(model.device_type) &&
      model.path_type === 'interstitial'
    "
    :model="model"
    :actions="actions"
    :isNewDeviceEditor="isNewDeviceEditor"
  />
  <RfRetentionModalMobileContent
    v-else-if="deviceType === 'mobileWeb'"
    ref="rfmodalMobile"
    :actions="actions"
    :model="model"
  />
  <RfRetentionModalContent
    v-else
    ref="rfmodal"
    :actions="actions"
    :deviceType="deviceType"
    :model="model"
    :zoomStyle="zoomStyle"
    :isNewDeviceEditor="isNewDeviceEditor"
    :isMobile="deviceType === 'androidSquare'"
    :newButtonStyles="newButtonStyles"
  />
</template>

<script setup>
import RfRetentionModalContent from "@/components/RfPathCreate/RfRetentionActions/RfRetentionModalContent.vue";
import RfRetentionModalMobileContent from "@/components/RfPathCreate/RfRetentionActions/RfRetentionModalMobileContent.vue";
import RfRetentionInterstitialMobileDevice from "./RfRetentionInterstitialMobileDevice.vue";

defineProps({
  actions: Object,
  deviceType: String,
  model: Object,
  zoomStyle: Object,
  isNewDeviceEditor: { type: Boolean, default: false },
  isMobile: { type: Boolean, default: false },
  newButtonStyles: { type: Boolean, default: false },
});
</script>
